module.exports = __webpack_public_path__ + "static/img/GU@2x.8fa783ac.jpg";